import AppComponent from '../base/app-component.ts';

/**
 * wc-cambio-password — Link "Cambia password" + modal con form.
 *
 * Posizionato nella card info account del profilo.
 * Validazione client-side + POST fetch a /auth/change-password.
 * Feedback via Weext dialogs.
 */
export class CambioPassword extends AppComponent {
  static override componentName = 'wc-cambio-password';

  protected override get templateId() { return 'cambio-password'; }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private bsModal: any = null;
  private modalEl: HTMLElement | null = null;

  protected override afterRender(): void {
    this.modalEl = this.$('[data-modal="change-password"]');
    if (this.modalEl) {
      // Sposta il modal a body per evitare problemi z-index/backdrop
      document.body.appendChild(this.modalEl);

      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      this.bsModal = new (globalThis as any).bootstrap.Modal(this.modalEl);

      this.modalEl.addEventListener('hidden.bs.modal', () => {
        (this.modalEl!.querySelector('[data-form="change-password"]') as HTMLFormElement)?.reset();
      });
    }

    this.delegate.on<MouseEvent>('click', '[data-action="open-change-password"]', (e) => {
      e.preventDefault();
      this.bsModal?.show();
    });

    const form = this.modalEl?.querySelector('[data-form="change-password"]') as HTMLFormElement | null;
    if (form) {
      form.addEventListener('submit', (e) => {
        e.preventDefault();
        this.handleSubmit();
      });
    }
  }

  protected override onDisconnected(): void {
    this.bsModal?.dispose();
    this.modalEl?.remove();
  }

  private async handleSubmit(): Promise<void> {
    if (!this.modalEl) return;
    const oldPwd = this.modalEl.querySelector('[data-field="old-password"]') as HTMLInputElement;
    const newPwd = this.modalEl.querySelector('[data-field="new-password"]') as HTMLInputElement;
    const confirmPwd = this.modalEl.querySelector('[data-field="confirm-password"]') as HTMLInputElement;
    const btn = this.modalEl.querySelector('[data-action="submit-password"]') as HTMLButtonElement;

    if (!oldPwd.value || !newPwd.value || !confirmPwd.value) {
      await Weext.alert('Compilare tutti i campi', {
        title: 'Attenzione',
        icon: 'bi-exclamation-triangle-fill',
        iconClass: 'text-warning',
      });
      return;
    }

    if (newPwd.value.length < 8) {
      await Weext.alert('La nuova password deve essere di almeno 8 caratteri', {
        title: 'Attenzione',
        icon: 'bi-exclamation-triangle-fill',
        iconClass: 'text-warning',
      });
      newPwd.focus();
      return;
    }

    if (newPwd.value !== confirmPwd.value) {
      await Weext.alert('Le password non coincidono', {
        title: 'Attenzione',
        icon: 'bi-exclamation-triangle-fill',
        iconClass: 'text-warning',
      });
      confirmPwd.focus();
      return;
    }

    btn.disabled = true;
    const originalHtml = btn.innerHTML;
    btn.innerHTML = '<span class="spinner-border spinner-border-sm me-1"></span>Attendere...';

    try {
      const resp = await fetch('/auth/change-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ oldPassword: oldPwd.value, newPassword: newPwd.value }),
      });

      if (resp.ok) {
        this.bsModal?.hide();
        Weext.toast('Password aggiornata', { type: 'success' });
      } else {
        const err = await resp.json().catch(() => ({})) as { error?: string };
        await Weext.alert(err.error || 'Errore nel cambio password', {
          title: 'Errore',
          icon: 'bi-x-circle-fill',
          iconClass: 'text-danger',
        });
      }
    } catch (err) {
      console.error('Errore cambio password:', err);
      await Weext.alert('Errore nel cambio password', {
        title: 'Errore',
        icon: 'bi-x-circle-fill',
        iconClass: 'text-danger',
      });
    } finally {
      btn.disabled = false;
      btn.innerHTML = originalHtml;
    }
  }
}
